import { initializeApp } from "firebase/app";
import { getDatabase, ref, child, get } from "firebase/database";
import { getAuth, signInAnonymously } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBGUww4_QeQmsbA_YbzgFs2nzOXesN9vEU",
    authDomain: "myinsights-fieldserviceapp.firebaseapp.com",
    databaseURL: "https://myinsights-fieldserviceapp-default-rtdb.firebaseio.com",
    projectId: "myinsights-fieldserviceapp",
    storageBucket: "myinsights-fieldserviceapp.appspot.com",
    messagingSenderId: "442509728875",
    appId: "1:442509728875:web:32e83496da344033c7a52e"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const auth = getAuth(app);

// Function to fetch data from Firebase Realtime Database
const fetchData = async (path) => {
    // Ensure user is signed in anonymously
    if (!auth.currentUser) {
        try {
            await signInAnonymously(auth);
        } catch (signInError) {
            console.error("Anonymous sign-in failed for Firebase:", signInError);
            return null; // or throw signInError if you want to handle it upstream
        }
    }
    const dbRef = ref(db, path);
    try {
        const snapshot = await get(dbRef);
        if (snapshot.exists()) {
            return snapshot.val();
        } else {
            return null;
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        return null;
    }
};

export { fetchData };